import { useCallback } from 'react';
import { useSetRecoilState } from 'recoil';

import { userState } from '@/recoil/atoms/common/user';
import { parseUserRealTime } from '../parser';
import { useUserQuery } from './user.gql.impl';

const useRefetchUser = () => {
  const setUser = useSetRecoilState(userState);

  const { refetch } = useUserQuery(
    {},
    {
      select: parseUserRealTime,
      enabled: false,
      useErrorBoundary: false,
      retry: 0,
    }
  );

  const refetchUser = useCallback(async () => {
    const result = await refetch();

    if (result.data) {
      setUser(result.data);
    }

    return result;
  }, [refetch, setUser]);

  return {
    refetchUser,
  };
};

export default useRefetchUser;
